import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { ArrowLeft } from "lucide-react"
import { UpgradeHeading } from "./UpgradeStates"

interface CheckoutLayoutProps {
  onBack: () => void
  /** While a payment runs: leaving would hide its result. */
  backDisabled?: boolean
  /** The order summary with the pay button; sticks while the form scrolls. */
  summary?: React.ReactNode
  /** The billing and payment sections (or an error). */
  children: React.ReactNode
}

/** Checkout view, framed like a settings page: the form on the left, the order summary on the right. */
export const CheckoutLayout: React.FC<CheckoutLayoutProps> = ({
  onBack,
  backDisabled = false,
  summary,
  children,
}) => {
  const { translate } = useTranslation()
  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col gap-6">
      <div className="flex flex-col gap-2">
        <Button
          variant="ghost"
          size="sm"
          className="-ml-3 w-fit text-muted-foreground"
          onClick={onBack}
          disabled={backDisabled}
        >
          <ArrowLeft />
          {translate("UPGRADE/BACK_TO_PLANS")}
        </Button>
        <UpgradeHeading
          title={translate("UPGRADE/CHECKOUT_TITLE")}
          description={translate("UPGRADE/TRUST_CANCEL")}
        />
      </div>
      <div className="grid items-start gap-10 lg:grid-cols-[minmax(0,3fr)_minmax(0,2fr)]">
        <div className="min-w-0">{children}</div>
        {summary && <div className="lg:sticky lg:top-0">{summary}</div>}
      </div>
    </div>
  )
}
